import { QueryKey } from 'react-query';

import BulkRequestListFilter from '../types';

export type TQueryKey = Exclude<QueryKey, string>; // TODO: react query 4버전에서는 기본입니다.

const bulkRequestKeys = {
  all: ['bulkRequest'],
  query: {
    lists: () => [...bulkRequestKeys.all, 'list'],
    list: (filter: BulkRequestListFilter) => [...bulkRequestKeys.all, 'list', filter],
    byId: (id: string) => [...bulkRequestKeys.all, 'item', { id }],
  },
  mutation: {
    delete: () => [...bulkRequestKeys.all, { method: 'DELETE' }],
    cancel: (id: string) => [...bulkRequestKeys.query.byId(id), { method: 'CANCEL' }],
    pause: (id: string) => [...bulkRequestKeys.query.byId(id), { method: 'PAUSE' }],
    updateTitle: (id: string) => [...bulkRequestKeys.query.byId(id), { method: 'UPDATE_TITLE' }],
    startBulkRequestTask: () => [
      ...bulkRequestKeys.query.lists(),
      { method: 'START_BULK_REQUEST_TASK' },
    ],
  },
};

export default bulkRequestKeys;
